import React, { forwardRef } from 'react';
import Turnstile from 'react-turnstile';

const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

const widgetErrorMessage =
  'Verification could not load. Please refresh the page. If it still fails, the Turnstile site key or allowed domain needs to be updated in Cloudflare.';

const TurnstileField = forwardRef(function TurnstileField(
  { onVerify, onExpire, onError, errorMessage },
  ref
) {
  if (!siteKey) {
    return (
      <div className="turnstile-panel turnstile-panel-error" role="alert">
        Turnstile site key is missing. Add `REACT_APP_TURNSTILE_SITE_KEY` before deploying.
      </div>
    );
  }

  return (
    <div className="turnstile-wrap">
      <div className="turnstile-panel">
        <Turnstile
          ref={ref}
          sitekey={siteKey}
          theme="light"
          size="flexible"
          retry="auto"
          refreshExpired="auto"
          onVerify={onVerify}
          onExpire={onExpire}
          onError={onError}
        />
      </div>
      {errorMessage ? (
        <div className="turnstile-panel turnstile-panel-error" role="alert">
          {errorMessage || widgetErrorMessage}
        </div>
      ) : null}
    </div>
  );
});

export { widgetErrorMessage };
export default TurnstileField;
